import { api } from "@/api"
import type { User } from "./types"
import { queryClient } from "@/queryClient"

export const activateUser = async (userId: User["id"]) => {
  await api.post(`/users/${userId}/activate/`)
  queryClient.invalidateQueries([BASE_USERS_QUERY_KEY])
}
